// @flow

import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { replace } from "connected-react-router";

import { getCart, addToCart } from "../actions/cart";

import HeroCheckout from "../components/organisms/HeroCheckout";
import CheckoutSteps from "../components/organisms/CheckoutSteps";
import CheckoutSummary from "../components/molecules/CheckoutSummary";
import CustomMeta from "../components/atoms/CustomMeta";

type PropsType = {};

const Checkout = (props: PropsType): React.Node => {
    const dispatch = useDispatch();
    const cart = useSelector((state: any): any => state.cart);
    const { location } = useSelector((state: any): any => state.router);
    const [summaryDefaultCollapsed] = React.useState(
        location.query.addItem ||
            (cart.clubQuickRegistration && cart.clubQuickRegistration.clubId)
            ? false
            : true
    );

    const [redirectUrl] = React.useState(
        location.query.checkoutRedirectUrl
            ? decodeURIComponent(location.query.checkoutRedirectUrl)
            : null
    );

    React.useEffect(() => {
        dispatch(replace(document.location.pathname));
    }, []); // eslint-disable-line

    return (
        <div className="checkout-page">
            <CustomMeta title="Cart" />

            <HeroCheckout
                heading="Checkout"
                beforeContent={
                    <CheckoutSummary
                        defaultCollapsed={summaryDefaultCollapsed}
                        className="hide-for-sm"
                    />
                }
            />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1 last-sm">
                        <CheckoutSummary className="show-for-sm" />
                    </div>

                    <div className="col-xs-12 col-sm-6">
                        {cart.items_count || location.query.addItem ? (
                            <CheckoutSteps successRedirectUrl={redirectUrl} />
                        ) : (
                            <div>
                                It looks like you've got nothing in your cart.
                                Start adding some items to checkout.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

Checkout.preload = ({ passed: { store } }: any): Promise<any> => {
    const { location } = store.getState().router;

    const handleQueryAddItem =
        (): any =>
        (dispatch: any, getState: any): any => {
            return new Promise((resolve, reject) => {
                if (location.query.addItem) {
                    return dispatch(
                        addToCart({
                            id: location.query.addItem,
                            quantity: location.query.addItemQuantity || 1,
                        })
                    )
                        .catch(error => {
                            console.error(error);
                        })
                        .finally(() => {
                            resolve();
                        });
                } else {
                    resolve();
                }
            });
        };

    return Promise.all([
        store.dispatch(handleQueryAddItem()).then(() => {
            store.dispatch(getCart());
        }),
    ]);
};

export default Checkout;
